import React from 'react';
import '../styles/secretariat.css';

const SecretariatCommitee = () => {
  return (
    <div>
      {/* <div className="banner-container">
        <img
          src={bannerImg}
          alt="Banner"
          className="banner-image"
        />
        <div className="banner-title">Secretariat Commitee</div>
      </div> */}

      <div className="content-section px-3 px-md-5">
        <p>
          The Research Committee is responsible for the development of the vision and strategy of MAHARISHI and for the monitoring of implementation.
        </p>
        <p>
          The Research Committee of MAHARISHI (Millet And OtHer Ancient GRains International ReSearcH Initiative) is inspired by this ancient wisdom, embracing a global, inclusive, and collaborative approach to food and nutritional security. We believe that through collective knowledge and coordinated action, the underutilized potential of millets and other ancient grains can be unlocked for the benefit of humanity and the planet.        
        </p>
         <p>
            The Research Committee serves as the backbone of the MAHARISHI initiative, fostering global collaboration to revive, promote, and advance scientific understanding and innovation in millets and other ancient grains. These grains, often overlooked in modern agriculture, offer climate resilience, nutritional richness, and a path to sustainable farming.        
        </p>
        <p>The Secretariat is a team composed of the required personnel to assist the Committees, Expert Working Groups, chairs and co-chairs to properly perform their tasks. The Secretariat will also provide liaison with Associated Programmes. The Secretariat is managed by the MAHARISHI Manager who is therefore responsible for the good performance of its tasks. </p>
        <p>The Secretariat is composed of personnel appointed or outsourced by the Managing Institution and of permanent or non‐permanent personnel of the Members provided as in‐kind contribution. The costs of the Secretariat will be paid on the MAHARISHI budget only for those incurred by the Managing Institution (including the costs of Subcontractor(s) involved in the Secretariat activities). </p>
      </div>

    </div>
  );
};

export default SecretariatCommitee;
